import { Component, OnInit, Renderer2 } from '@angular/core';

import { DashboardServiceService } from '@admin/shared/services/dashboard-service.service';

import { UserProfileService } from '@core/services/user.service';
import { AuthenticationService } from '@core/services/auth.service';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss',
  standalone: false,
})
export class OnboardingComponent implements OnInit {
  visible: boolean = false;
  currentStep = -1;
  userData: any = null;
  private scriptElement!: HTMLScriptElement;
  private linkElement!: HTMLLinkElement;

  constructor(
    private userProfileService: UserProfileService,
    private dashboardService: DashboardServiceService,
    private authService: AuthenticationService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    /*this.checkPreBoardingStatus()?.subscribe({
      next: (res) => {
        if (res.docs && res.docs.length) {
          this.getOnboardingStep();
        } else {

        }
      },
      error: () => {
        this.getOnboardingStep();
      },
    });*/
    this.getOnboardingStep();
    // update user data
    this.userProfileService.getUserDetails().subscribe();
    // Load Calendly CSS
    this.linkElement = this.renderer.createElement('link');
    this.linkElement.rel = 'stylesheet';
    this.linkElement.href = 'https://assets.calendly.com/assets/external/widget.css';
    this.renderer.appendChild(document.head, this.linkElement);

    // Load Calendly script
    this.scriptElement = this.renderer.createElement('script');
    this.scriptElement.src = 'https://assets.calendly.com/assets/external/widget.js';
    this.scriptElement.type = 'text/javascript';
    this.scriptElement.async = true;
    this.renderer.appendChild(document.body, this.scriptElement);
  }

  openCalendly() {
    const calendly = (window as any).Calendly;
    if (calendly && calendly.initPopupWidget) {
      calendly.initPopupWidget({
        url: 'https://calendly.com/confetechnologies/30min',
      });
    } else {
      console.error('Calendly script not loaded yet');
    }
  }

  getOnboardingStep() {
    this.userProfileService.getUser().subscribe({
      next: (res) => {
        this.userData = res;
        if (this.currentStep === 5) return;
        if (this.userData && this.userData.workspaces && this.userData.workspaces.length) {
          const currentWorkspace = res.workspaces.find(
            (workspace: { uuid: any }) => workspace.uuid === res.settings.active_workspace
          );
          if (currentWorkspace) {
            // Set the workspace in the dashboard service
            this.dashboardService.setWorkspace(currentWorkspace);
          }
          this.currentStep = 1;
          /*if (this.userData.workspaces[0].connected_accounts.length) {
            this.currentStep = 4;
          } else {
            const subscription = this.isStepSkipped(4).subscribe((stepSkipped) => {
              if (stepSkipped) {
                this.currentStep = 5;
              } else {
                this.currentStep = 4;
              }
            });
            subscription.unsubscribe();
          }*/
        } else {
          if (this.currentStep === -1) {
            if (!this.userData?.settings?.timezone) {
              this.currentStep = 1;
            } else {
              this.currentStep = 2;
            }
          }
        }
      },
    });
  }

  /* isStepSkipped(currentStep: number): Observable<boolean> {
    return this.userProfileService.getSkippedOnboardingSteps().pipe(
      map((steps: number[]) => {
        return steps.indexOf(currentStep) !== -1;
      })
    );
  }*/

  nextStep(event: any) {
    if (event.moveToNextStep) {
      if (event.updateUser) {
        this.userProfileService.getUserDetails().subscribe(() => this.getOnboardingStep());
        // this.currentStep = this.currentStep + 1;
      } else {
        if (this.currentStep === 4) {
          // update user move to dashboard
        } else {
          this.currentStep = this.currentStep + 1;
        }
      }
    }
  }

  /*checkPreBoardingStatus() {
    return this.onboardingService.getUserQuestionsData();
  }*/

  /*moveToCertainStep(step: number) {
    if (step) {
      this.currentStep = step;
    }
  }*/

  signOut() {
    this.authService.signOut();
  }
}
